import React from 'react';
import { useSelector } from 'react-redux';
import BadgeGroup from '../components/BadgeGroup';
import '../global-sass/main.scss';

const WidgetContainer = () => {
	const { vehicleBadges } = useSelector((state) => state);
	return (
		<>
			<BadgeGroup vehicleBadges={vehicleBadges} />
		</>
	);
};

export default WidgetContainer;
